export const INTEGRATION_NAME = 'VercelAI' as const;
